const isEmptyString = (val: string) => {
  return typeof val === 'string' && val.length === 0;
};

export default isEmptyString;
